<template>
  <div class="mt-2 px-6 template-job-profiles-list-container">
    <LibrariesSkeletonLoader
      class="ml-6 mr-6"
      :is-loading="pageLoading || listLoading"
      is-requisition
    />

    <div
      v-if="!pageLoading && !listLoading"
    >
      <div class="d-flex justify-end mb-4">
        <v-btn
          color="primary"
          variant="flat"
          rounded="lg"
          @click="openCreateTemplateModal"
        >
          Create Template
        </v-btn>
      </div>
      <LibraryList>
        <LibraryListItemWrapper
          v-for="{
            ulid,
            title,
            location,
            job_level: jobLevel,
          } in jobProfileTemplates"
          :key="ulid"
        >
          <router-link
            :to="{ query: { preview: ulid, type: 'jobProfile' } }"
          >
            <DraftJobProfilesItem
              v-bind="{
                title, location, jobLevel,
              }"
            />
          </router-link>
        </LibraryListItemWrapper>
      </LibraryList>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { subscribeToFilterUpdates, unsubscribeToFilterUpdates } from '@/helpers/filterDispatcher';
import LibrariesSkeletonLoader
  from '@/components/shared/SkeletonLoaders/LibrariesSkeletonLoader.vue';
import { useAppBase } from '@/stores/app/base';
import { useAppLoading } from '@/stores/app/loading';
import { useJobProfileTemplates } from '@/stores/jobProfiles/jobProfileTemplates';
import { useFilters } from '@/stores/filters/filters';
import { useModals } from '@/stores/modals/modals';
import DraftJobProfilesItem from '@/components/jobProfiles/DraftJobProfilesItem.vue';
import LibraryListItemWrapper from '@/components/shared/LibraryListItemWrapper.vue';
import LibraryList from '@/components/shared/LibraryList.vue';

const emit = defineEmits(['track-page-load']);

const route = useRoute();
const router = useRouter();

const { pageLoading, listLoading } = storeToRefs(useAppLoading());
const { jobProfileTemplates } = storeToRefs(useJobProfileTemplates());
const { loadJobProfileTemplates } = useJobProfileTemplates();
const { setFilterConfig } = useFilters();
const { showFilterBarSettings } = useAppBase();
const { setModal } = useModals();

const openCreateTemplateModal = () => {
  setModal({ field: 'createProfileTemplate', value: true });
};

const loadPage = async (params) => {
  await loadJobProfileTemplates(params);
};

onMounted(async () => {
  subscribeToFilterUpdates(loadPage);

  setFilterConfig({
    module: 'jobProfiles',
    showMyJobs: false,
    datepicker: false,
  });

  showFilterBarSettings({ route: route.name });

  await loadPage({
    routeQuery: route.query,
    router,
    page: route.query?.page || 1,
  });

  emit('track-page-load', { page: 'Job Profile Templates: Open' });
});

onBeforeUnmount(() => {
  unsubscribeToFilterUpdates(loadPage);

  setFilterConfig({
    subMenuType: null,
  });
});
</script>
